import { TypographyOptions } from "@mui/material/styles/createTypography";

/**
 * Roboto 14px base (loaded in public/index.html). `h3` is the page-title variant used
 * by every screen; `h6` is the card-header variant.
 */
const typography: TypographyOptions = {
  fontFamily: [
    "Roboto",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "sans-serif",
  ].join(","),
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontSize: "2rem",
    fontWeight: 500,
    lineHeight: 1.25,
  },
  h2: {
    fontSize: "1.75rem",
    fontWeight: 500,
    lineHeight: 1.25,
  },
  h3: {
    fontSize: "1.375rem",
    fontWeight: 500,
    lineHeight: 1.3,
  },
  h4: {
    fontSize: "1.125rem",
    fontWeight: 500,
    lineHeight: 1.3,
  },
  h5: {
    fontSize: "1.0625rem",
    fontWeight: 500,
    lineHeight: 1.3,
  },
  h6: {
    fontSize: "0.9375rem",
    fontWeight: 500,
    lineHeight: 1.4,
  },
  body1: {
    fontSize: "0.875rem",
    lineHeight: 1.5,
  },
  body2: {
    fontSize: "0.8125rem",
    lineHeight: 1.5,
  },
  button: {
    textTransform: "none",
    fontWeight: 500,
  },
};

export default typography;
